import React from "react";
import { useTranslation } from "react-i18next";
import EASkeletonLoader from "../../shared/EASkeletonLoader";
import useBasketExtras from "../hooks/useBasketExtras";
import useBasketManager from "../hooks/useBasketManager";
import { HiOutlineReceiptPercent } from "react-icons/hi2";
import EAButton from "../../shared/Buttons/EAButton";
import { BiInfoCircle } from "react-icons/bi";
import HtmlTooltip from "@mui/material/Tooltip";

interface IProps {
  handleGetBasket: Function;
}

const BasketExtras: React.FC<IProps> = ({ handleGetBasket }) => {
  const { t } = useTranslation();
  const { extras, loading } = useBasketExtras();
  const { handleAddBasketLimited } = useBasketManager();

  if (loading) return <EASkeletonLoader height="120px" />;

  if (!extras || extras.length === 0) {
    return null;
  }

  const handleAdd = async (extra: any) => {
    await handleAddBasketLimited(extra, 1);
    handleGetBasket();
  };

  return (
    <div className="basket-extras">
      <div className="basket-extras__header">
        <h5 className="basket-extras__title">{t("dodatki_do_zamowienia")}</h5>
      </div>
      <div className="basket-extras__list">
        {extras.map((extra: any) => {
          const isDiscount = Number(extra.price) !== Number(extra.listPrice ?? extra.price);
          return (
            <div key={extra.objectId} className="basket-extras__item">
              <div className="basket-extras-item__left">
                <div className="basket-extras-item-left__icon">
                  <HiOutlineReceiptPercent className="basket-extras-icon" />
                </div>
                <div className="basket-extras-item-left__title">
                  <b>{extra.displayWebName || extra.name}</b>
                  <HtmlTooltip
                    placement="right"
                    title={
                      <>
                        <article className="" dangerouslySetInnerHTML={{ __html: extra.description }}></article>
                      </>
                    }
                  >
                    <b>
                      <BiInfoCircle className="tooltip-icon" />
                    </b>
                  </HtmlTooltip>
                </div>
              </div>
              <div className="basket-extras-item__right">
                <div className="basket-extras-item-right__price">
                  <div className="price-container">
                    <b className={`price ${isDiscount ? "price-through" : ""}`}>
                      {Number(extra.listPrice ?? extra.price).toFixed(2)} {t("zl")}
                    </b>
                    {isDiscount && (
                      <b className={`price ${isDiscount ? "price-through-color" : ""}`}>
                        {Number(extra.price).toFixed(2)} {t("zl")}
                      </b>
                    )}
                  </div>
                </div>
                <div className="basket-extras-item-right__actions">
                  <EAButton title={t("dodaj")} onClick={() => handleAdd(extra)} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BasketExtras;


